import { useState } from 'react';
import { Input, Tooltip, App, Button } from 'antd';
import { CopyOutlined, EyeOutlined } from '@ant-design/icons';
import { ConfigRevealModal } from '../../components/ConfigReveal/ConfigRevealModal';

interface ConfigValueProps {
  configKey: string;
}

export const ConfigValue = ({ configKey }: ConfigValueProps) => {
  const { message } = App.useApp();
  const [copied, setCopied] = useState(false);
  const [revealedValue, setRevealedValue] = useState<string | null>(null);
  const [revealOpen, setRevealOpen] = useState(false);

  const handleCopy = async () => {
    if (revealedValue === null) {
      setRevealOpen(true);
      return;
    }
    try {
      await navigator.clipboard.writeText(revealedValue);
      setCopied(true);
      message.success('Copied to clipboard');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      message.error('Failed to copy');
    }
  };

  return (
    <span className="admin-docs-config-value">
      <code className="admin-docs-config-key">{configKey}</code>
      <Input
        value={revealedValue ?? '••••••••'}
        readOnly
        size="small"
        type={revealedValue === null ? 'password' : 'text'}
        className="admin-docs-config-input"
      />
      <Tooltip title="Show value">
        <Button
          type="text"
          size="small"
          icon={<EyeOutlined />}
          onClick={() => setRevealOpen(true)}
        />
      </Tooltip>
      <Tooltip title={copied ? 'Copied!' : revealedValue === null ? 'Confirm password to copy' : 'Copy value'}>
        <CopyOutlined
          className="admin-docs-config-copy"
          onClick={(e) => {
            e.stopPropagation();
            handleCopy();
          }}
        />
      </Tooltip>
      <ConfigRevealModal
        configKey={configKey}
        open={revealOpen}
        showRevealedValue={false}
        onRevealed={(value) => {
          setRevealedValue(value);
          setRevealOpen(false);
        }}
        onClose={() => setRevealOpen(false)}
      />
    </span>
  );
};
